// extracted by mini-css-extract-plugin
export default {"header":"DistributorsTable_header__FRHXF"};